import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {Button, Dropdown, TextField} from '@goguardian/based';
import ProgressSteps from '../progress';
import {setSurveyReferrals} from '_shared/actions';

import Select from 'react-select';

import style from './style.scss';
import 'react-select/dist/react-select.css';

class SurveyStart extends React.Component {

  constructor(...args) {
    super(...args);

    const referrals = this.props.referrals ?
      this.props.referrals.split(';').map((value) => {
        return {value: value, label: value};
      }) : [];
    this.state = {
      referrals: referrals,
      other: ''
    };

    this.setReferrals = this.setReferrals.bind(this);
    this.setOther = this.setOther.bind(this);
    this.next = this.next.bind(this);
  }

  setOther(other) {
    this.setState({
      other: other
    });
  }

  setReferrals(referrals) {
    this.setState({
      referrals: referrals
    });
  }

  next() {
    const { referrals, other } = this.state;

    let selections = referrals;
    if (other !== '') {
      selections = referrals.concat([{value: `Other: ${other}`}]);
    }

    const referralList = selections.map(item => item.value).join(';');

    this.props.dispatch(setSurveyReferrals(referralList));
    this.props.router.push({
      pathname: '/survey/questions'
    });
  }

  render() {
    const { referrals } = this.state;
    const sources = [
      {value: 'Advertisement', label: 'Advertisement'},
      {value: 'Email from GoGuardian', label: 'Email from GoGuardian'},
      {value: 'GoGuardian Blog, video or white paper', label: 'GoGuardian Blog, video or white paper'},
      {value: 'News article (Forbes, NPR, Huffington Post, etc.)', label: 'News article (Forbes, NPR, Huffington Post, etc.)'},
      {value: 'Referral from a school district', label: 'Referral from a school district'},
      {value: 'Reseller or partner', label: 'Reseller or partner'},
      {value: 'Social Media', label: 'Social Media'},
      {value: 'Trade Show', label: 'Trade Show'},
      {value: 'Web search', label: 'Web search'},
      {value: 'Flyer or brochure (print or digital)', label: 'Flyer or brochure (print or digital)'},
      {value: 'Other: please list', label: 'Other: please list'}
    ];
    const showOtherField = referrals.map(item => item.value).indexOf('Other: please list') !== -1;

    return (
      <div>
        <ProgressSteps
          steps={['Sign Up', 'Quick Questions', 'Get Started']}
          current={1} />
        <div className={style.surveyContainer}>
          <div className={style.icon}></div>
          <h3>BEFORE WE GET YOU SET UP, PLEASE TELL US</h3>
          <h2>How did you hear about GoGuardian?</h2>
          <h3>SELECT ALL THAT APPLY</h3>
          <div>
            <Select
              className={style.dropdown}
              value={referrals}
              multi={true}
              options={sources}
              onChange={this.setReferrals}
              />
            {showOtherField &&
              <TextField
                className={style.otherField}
                label="Please Specify the Other Means"
                value={this.state.other}
                onChange={this.setOther}
                />
            }
            <Button
              onClick={this.next}>
              Next
            </Button>
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    referrals: state.surveyReferrals
  };
};

export default connect(mapStateToProps)(withRouter(SurveyStart));



/** WEBPACK FOOTER **
 ** ./src/app/components/survey/start/index.jsx
 **/